import { ApiError } from './api.error';
import { County } from './api.types';
import { searchLocations } from './location.api';

// The county list is cached in localStorage under 'counties' (named in the Cookies policy).
// County ids change when the database is rebuilt, so the cache must be able to heal itself.
const COUNTIES_CACHE_KEY = 'counties';

export const readCachedCounties = (): County[] | null => {
  try {
    const counties = JSON.parse(localStorage.getItem(COUNTIES_CACHE_KEY) || 'null');
    if (Array.isArray(counties) && counties.length > 0) {
      return counties;
    }
  } catch {
    // Unreadable cache: treated as missing, so the list is fetched again.
  }
  return null;
};

export const forgetCachedCounties = () => {
  try {
    localStorage.removeItem(COUNTIES_CACHE_KEY);
  } catch {
    // Storage unavailable: nothing to forget.
  }
};

export const fetchCounties = async (accessToken: string | null = null): Promise<County[]> => {
  const { counties } = await searchLocations(1, 500, null, null, accessToken);
  if (counties.length > 0) {
    try {
      localStorage.setItem(COUNTIES_CACHE_KEY, JSON.stringify(counties));
    } catch {
      // Storage full or blocked: the list still works for this page view.
    }
  }
  return counties;
};

// A cached county the backend no longer knows (404) means the whole cached list is stale.
export const isUnknownCountyError = (error: unknown) => error instanceof ApiError && error.status === 404;
